'use client'

import { Loader2Icon } from 'lucide-react'

import { BillCard } from '@/components/legislative-tracker/BillCard'
import { RevealSection } from '@/components/RevealSection'
import { Pagination } from '@/components/ui/pagination'
import { useLegislativeContext } from '@/providers/LegislativeProvider'
import { cn } from '@/utilities/ui'

/**
 * Displays bills in a paginated list layout.
 * Pagination is server-driven via the /api/frontend/bills endpoint.
 */
export const BillPaginatedList = () => {
  const {
    selectedLegislativeTab,
    billTopics,
    bills,
    totalBills,
    billsLoading,
    isSearching,
    searchTerm,
    page,
    setPage,
  } = useLegislativeContext()

  const perPage = 6

  const showLoading = isSearching || billsLoading

  return (
    <div className="flex min-w-0 flex-col gap-4">
      <div className="flex flex-col gap-4 lg:min-h-[858px]">
        <RevealSection once={true} className="flex grow-0 items-center gap-2">
          <p className="font-body text-base font-normal text-foreground">
            {showLoading
              ? 'Searching...'
              : `${totalBills} bill${totalBills !== 1 ? 's' : ''} found`}
          </p>
          {showLoading && <Loader2Icon className="size-4 animate-spin text-muted-foreground" />}
        </RevealSection>

        <RevealSection
          once={true}
          className={cn(
            'flex flex-1 flex-wrap items-start justify-start gap-2 sm:grid sm:auto-rows-max sm:grid-cols-2 md:gap-4 [&>.bill-card]:w-full [&>.bill-card]:max-w-full [&>.bill-card]:min-w-[306px]',
            showLoading && 'pointer-events-none opacity-50',
          )}
        >
          {bills.map((bill) => (
            <BillCard
              key={`${selectedLegislativeTab}-${bill.id}`}
              bill={bill}
              allBillTopics={billTopics}
              useBillProgress
            />
          ))}
          {!showLoading && bills.length === 0 && searchTerm && (
            <p className="col-span-2 text-muted-foreground">
              No bills found matching &quot;{searchTerm}&quot;
            </p>
          )}
        </RevealSection>
      </div>
      <Pagination
        className="shrink-0"
        numResults={totalBills}
        resultsPerPage={perPage}
        currentPage={page}
        onPageChange={setPage}
      />
    </div>
  )
}
